<template>
  <div>
    <NavBarBreadCrumbOut class="z-1" />
    <div class="p-relative">
      <v-container class="container-img">
        <img class="bg-img" :src="getCouncilBackgroundImage" />
        <div class="title-welcome">
          <v-row>
            <h4 class="welcome mb-5">Olá, {{ agentName }}</h4>
          </v-row>
          <v-row>
            <span class="welcome-description">Escolha abaixo se deseja doar via boleto, se quer nos avisar de uma transferência que já fez ou se quer acessar seu histórico de doações.</span>
          </v-row>
        </div>

        <v-row>
          <v-col v-if="hasBankBillet">
            <v-card class="card-start">
              <v-row>
                <v-col cols="12">
                  <h4 class="mb-2" color="primary">Quer doar via boleto?</h4>
                  <span class="sub-title"
                    >Acesse o formulário de doação e gere os boletos.</span
                  >
                </v-col>
                <v-col>
                  <v-btn
                    color="primary"
                    :to="{
                      name: routes.web.NewDonations,
                      params: { paymentMethod: 'boleto' }
                    }"
                    ><i class="fal fa-barcode-read icon-pay"></i>Doar por
                    boleto</v-btn
                  >
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <v-col>
            <v-card class="card-start">
              <v-row>
                <v-col cols="12" md="6">
                  <h4 color="primary">Meu histórico de doações</h4>
                  <span class="sub-title"
                    >Confira a lista das doações, emita a 2ª via de boletos e
                    mais...</span
                  >
                </v-col>
                <v-col cols="12">
                  <v-btn color="primary" :to="{ name: routes.web.ListDonations }"
                    ><i class="fal fa-hand-holding-usd icon-pay"></i>Minhas
                    doações</v-btn
                  >
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>

        <v-row v-if="hasBankTransfer">
          <v-col cols="12" md="6">
            <v-card class="card-start">
              <v-row>
                <v-col cols="12">
                  <h4 color="primary">Doou via transferência?</h4>
                  <span class="sub-title"
                    >Para fazer um DOC/TED utilize os dados bancários abaixo e depois de realizado nos envie o comprovante clicando abaixo.</span
                  >
                </v-col>
                <v-col cols="12">
                  <v-btn
                    color="primary"
                    :to="{
                      name: routes.web.NewDonations,
                      params: { paymentMethod: 'transferencia' }
                    }"
                    ><i class="fal fa-file-alt icon-pay"></i>Enviar
                    comprovante</v-btn
                  >
                </v-col>
                <v-col cols="12">
                  <h5 color="primary">Dados para transferência</h5>
                </v-col>
                <v-col cols="12">
                  <span class="sub-title"
                    >CNPJ:
                    <span class="sub-title1">{{
                      council.entityViewModel.document
                    }}</span></span
                  >
                </v-col>
                <v-col cols="12">
                  <span class="sub-title"
                    >Banco: <span class="sub-title1">Banco do Brasil</span></span
                  >
                </v-col>
                <v-col cols="12">
                  <span class="sub-title"
                    >Agência:
                    <span class="sub-title1">{{ council.agency }}</span></span
                  >
                </v-col>
                <v-col cols="12">
                  <span class="sub-title"
                    >C/C:
                    <span class="sub-title1"
                      >{{ council.account }}-{{ council.digit }}</span
                    ></span
                  >
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card class="card-start">
              <v-row>
                <v-col cols="12">
                  <h4 color="primary">Fez uma doação via DARF, diretamente pela declaração do imposto de renda?</h4>
                  <span class="sub-title"
                    >Envie seu comprovante por aqui.</span
                  >
                </v-col>
                <v-col cols="12">
                  <v-btn
                    color="primary"
                    :to="{
                      name: routes.web.NewDonations,
                      params: { paymentMethod: 'transferencia' }
                    }"
                    ><i class="fal fa-file-alt icon-pay"></i>Enviar
                    comprovante</v-btn
                  >
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import NavBarBreadCrumbOut from "@/components/NavBarBreadCrumbOut";
import Routes from "@/router/names.js";
import DonationService from "@/scripts/services/donation.service";
import EntityService from "@/scripts/services/entity.service";
import PaymentMethods from "@/scripts/enums/paymentMethods.enum";
import { mapGetters } from "vuex";

export default {
  name: "Start",
  inject: ["theme"],
  components: {
    NavBarBreadCrumbOut
  },
  data: () => ({
    routes: Routes,
    paymentMethodList: [],
    donationService: new DonationService(),
    entityService: new EntityService(),
    agentName: "",
    council: {
      entityViewModel: { document: "" },
      account: "",
      digit: ""
    }
  }),
  computed: {    
    ...mapGetters(["getCouncilBackgroundImage"]),
    hasBankBillet() {
      return this.paymentMethodList.find(
        p => p.id == PaymentMethods.BankBillet
      );
    },
    hasBankTransfer() {
      return this.paymentMethodList.find(
        p => p.id == PaymentMethods.BankTransfer
      );
    }
  },
  created() {
    this.agentName = JSON.parse(localStorage.getItem("name"));
    this.donationService.listAllPaymentMethodsByLoggedAgent().then(result => {
      this.paymentMethodList = result;
    });
    this.entityService
      .getCouncilById(this.$route.params.councilId)
      .then(result => (this.council = result));
  },
  methods: {}
};
</script>